import { render, staticRenderFns } from "./EmailPanel.vue?vue&type=template&id=ee2c3c0a&scoped=true&"
import script from "./EmailPanel.vue?vue&type=script&lang=js&"
export * from "./EmailPanel.vue?vue&type=script&lang=js&"
import style0 from "./EmailPanel.vue?vue&type=style&index=0&id=ee2c3c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2c3c0a",
  null
  
)

export default component.exports